import { SxProp, View } from 'dripsy';
import ReactNative, { StyleProp, ViewStyle } from 'react-native';
import React from 'react';

interface PageItemProps {
  sx?: SxProp;
  style?: StyleProp<ViewStyle>;
  ref?: React.Ref<ReactNative.View>;
  onLayout?: (event: ReactNative.LayoutChangeEvent) => void;
}

export const PageItem: React.FC<PageItemProps> = ({ sx, style, ref, onLayout, children }) => {
  return (
    <View sx={{ ...styles.container, ...sx }} style={style} ref={ref} onLayout={onLayout}>
      {children}
    </View>
  );
};

enum StyleName {
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    paddingY: '$7',
    borderWidth: 1,
    borderColor: '$borderPageItem',
    borderRadius: '$radius3',
    backgroundColor: '$backgroundPrimary',
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.1,
    shadowRadius: 15,
    elevation: 10
  }
};
